import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_POLICY_DATA,
  GET_POLICY_DETAIL_DATA,
  GET_K2_REPORT_DATETIME_DATA,
  GET_K2_REPORT_GROUP_DATA,
  GET_K2_REPORT_INDIVIDUAL_DATA,
  GET_K2_REPORT_SUMMARY_DATA,
  CHECK_AGENT_IS_LEAF_NODE,
  GET_TEAM_POLICY_DATA,
} from './constants.js';
import {
  setPolicyAction,
  setPolicyDetailAction,
  setK2ReportDateTimeDataAction,
  setK2ReportSummaryDataAction,
  setK2ReportTableDataAction,
  setTeamPolicyAction,
  fetchPolicyListStartAction,
  fetchPolicyListSuccessAction,
} from './actions.js';
import {
  getPolicyAgentService,
  getPolicyAgentByIdService,
  getK2ReportDatetimeListService,
  getK2ReportGroupListService,
  getK2ReportIndividualListService,
  getK2ReportSummaryService,
  getAgentIsLeafNodeService,
  getTeamPolicyListService,
} from '@services/k2Report/k2Report.js';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { delay } from '@helpers/utils/utils.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';

export function* getK2ReportDatetimeData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getK2ReportDatetimeListService, payload);
    yield put(loadingSuccess());

    yield put(setK2ReportDateTimeDataAction(response.data));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getAgentIsLeafNodeData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getAgentIsLeafNodeService, payload);
    yield put(loadingSuccess());
    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getK2ReportGroupData({ payload }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getK2ReportGroupListService, payload);
    yield put(loadingSuccess());

    yield put(setK2ReportTableDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getK2ReportIndividualData({ payload }) {
  try {
    yield put(loadingRequest());
    yield delay(1000);
    const response = yield call(getK2ReportIndividualListService, payload);
    yield put(loadingSuccess());

    yield put(setK2ReportTableDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getK2ReportSummaryData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getK2ReportSummaryService, payload);
    yield put(loadingSuccess());

    yield put(setK2ReportSummaryDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getPolicyData({ payload }) {
  try {
    yield put(fetchPolicyListStartAction());
    const response = yield call(getPolicyAgentService, payload);
    yield put(fetchPolicyListSuccessAction());

    yield put(setPolicyAction(response));
  } catch (err) {
    yield put(fetchPolicyListSuccessAction());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {},
    });
  }
}

export function* getPolicyDetailData({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPolicyAgentByIdService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());

    yield put(setPolicyDetailAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getTeamPolicyData({ payload }) {
  try {
    yield put(fetchPolicyListStartAction());
    const response = yield call(getTeamPolicyListService, payload);
    yield put(fetchPolicyListSuccessAction());

    yield put(setTeamPolicyAction(response));
  } catch (err) {
    yield put(fetchPolicyListSuccessAction());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {},
    });
  }
}

export default function* k2ReportSaga() {
  yield takeLatest(GET_K2_REPORT_DATETIME_DATA, getK2ReportDatetimeData);
  yield takeLatest(GET_K2_REPORT_GROUP_DATA, getK2ReportGroupData);
  yield takeLatest(GET_K2_REPORT_INDIVIDUAL_DATA, getK2ReportIndividualData);
  yield takeLatest(GET_K2_REPORT_SUMMARY_DATA, getK2ReportSummaryData);
  yield takeLatest(GET_POLICY_DATA, getPolicyData);
  yield takeLatest(GET_POLICY_DETAIL_DATA, getPolicyDetailData);
  yield takeLatest(CHECK_AGENT_IS_LEAF_NODE, getAgentIsLeafNodeData);
  yield takeLatest(GET_TEAM_POLICY_DATA, getTeamPolicyData);
}
